export default __webpack_public_path__ + "static/media/email_1.703918df.svg";